import React from 'react';
import { VisibilityOnOutline, VisibilityOffOutline } from '@olist/design-system-icons';
import { SuffixIcon } from './styles.js';

const SuffixIconInputPassword = (setIsPasswordVisible, isPasswordVisible) => {
    return (React.createElement(SuffixIcon, { onClick: () => setIsPasswordVisible(!isPasswordVisible), "aria-label": !isPasswordVisible ? 'mostrar senha' : 'ocultar senha', type: "button" }, isPasswordVisible ? (React.createElement(VisibilityOnOutline, { width: 24, height: 24 })) : (React.createElement(VisibilityOffOutline, { width: 24, height: 24 }))));
};

export { SuffixIconInputPassword };
